import api from '@pray/shared/utils/api';

export async function getAllOffers({
  artistId = '',
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  status = '',
} = {}) {
  const params = {
    artist_id: artistId,
  };

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  if (status) params.status = status;

  const url = `/web/studio/offers`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
